import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';
import { formatTaxId } from '@rivethealth/data/tax-id';

@Directive({
  selector: '[tax-id-mask]',
})
export class TaxIdMaskDirective {
  constructor(public ngControl: NgControl) {}

  @HostListener('ngModelChange', ['$event'])
  onModelChange(event: any) {
    this.ngControl.valueAccessor!.writeValue(formatTaxId(event));
  }
}
